import React, { createContext, useState } from 'react';

// Crear el contexto
export const FormContext = createContext();

// Crear el proveedor del contexto
export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    currentStep: 1,
  });

  // Función para actualizar los datos del formulario
  const updateFormData = (newData) => {
    setFormData(prevData => ({
      ...prevData,
      ...newData,
    }));
  };

  // Función para resetear el formulario
  const resetFormData = () => {
    setFormData({
      currentStep: 1,
    });
  };

  return (
    <FormContext.Provider value={{ formData, updateFormData, resetFormData }}>
      {children}
    </FormContext.Provider>
  );
};
